import logo from './logo.webp'
import newsImage from './newsImage.jpg'
export const theme = {
  color: {
    primary: " #e30613",
    primaryHover: "#cc0511",
  },
  logoImage: logo,
  backend: "https://downloads.suer.de/",
  directory: "/kiosk",
  header: {
    customer: "",
    title: "Suer Downloads",
    lineHeader: true,
  },
  additionalLanguages: [
    {
      language: 'fi',
      backend: "https://downloads.suer.de/fi/",
      title: "Suer Lataukset",
    }
  ],
  info: [
    {
      text: 'Impressum',
      link: 'https://www.suer.de/impressum',
      fi: {
        text: "Painatus",
        link: "https://www.suer.de/en/impressum"
      }
    },
    {
      text: 'Datenschutz',
      link: 'https://www.suer.de/datenschutzerklaerung',
      fi: {
        text: "Tietosuoja",
        link: "https://www.suer.de/en/datenschutzerklaerung"
      }
    },
  ],
  newsSlider: {
    image: newsImage,
  },
};